import Seo from "@/components/seo/Seo"

import CalculatorHeader from "@/components/sections/calcpage/CalculatorHeader"
import CalcContainer from "@/components/sections/calcpage/CalcContainer"
import FaqTrustSection from "@/components/sections/calcpage/FaqTrustSection"
import CalculatorTrustStrip from "@/components/sections/calcpage/CalculatorTrustStrip"

import SectionReveal from "@/components/common/SectionReveal"

export default function AirbnbCalculator() {
  return (
    <>
      <Seo
        title="Airbnb Revenue Calculator | Zenia Stays"
        description="Estimate your Airbnb and short-term rental earnings using the Zenia Stays revenue calculator."
        canonical="https://zeniastays.com/revenue-calc"
      />

      <CalculatorHeader />

      <SectionReveal>
        <CalcContainer />
      </SectionReveal>

      <SectionReveal delay={0.05}>
        <CalculatorTrustStrip />
      </SectionReveal>

      <SectionReveal delay={0.08}>
        <FaqTrustSection />
      </SectionReveal>

    </>
  )
}